import {trackEvent} from "../utils/plausible";

export function componentFavorite() {
    Alpine.data('favorite', (post_id = false) => ({
        user_is_logged_in: (site_objects.user_is_logged_in === 'true'),
        is_favorite: false,

        init() {
            if(this.user_is_logged_in){
                this.is_favorite = this.get_favorite_status()
            }
        },

        trigger_favorite: {
            ["@click"](e) {
                if(this.user_is_logged_in){
                    this.is_favorite = this.update_favorite_status()
                }
            },

        },

        text: {
            ["x-text"]() {
                return (this.is_favorite) ? AlpineI18n.t('remove_favorit') : AlpineI18n.t('favorit')
            }
        },

        async get_favorite_status() {
            let formData = new FormData(),
            status;

            formData.append('action', 'get_favorite_status')
            formData.append('post_id', post_id)

            status = await (await fetch(site_objects.ajax_url, {
                method: "POST",
                body: formData
            })).json();

            this.is_favorite =  status.data.is_favorite;
        },

        async update_favorite_status() {
            let formData = new FormData(),
                status;

            formData.append('action', 'update_favorite_status')
            formData.append('post_id', post_id)

            status = await (await fetch(site_objects.ajax_url, {
                method: "POST",
                body: formData
            })).json();

            trackEvent('Favorite', {
                props: {
                    action: status.data.action,
                    url: status.data.url,
                    title: status.data.title,
                    type: status.data.type,
                }
            })

            this.is_favorite = status.data.is_favorite;
        }
    }))
}
